// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__24lPy","left":"styles_left__A4tCW","desktopActions":"styles_desktopActions__2NjyQ","title":"styles_title__UxQ9j"};